import {
  get,
  post,
  patch,
  // deletes,
  deletev2,
} from './base/index';

export default {
  getContents: (data = {}) => {
    const params = { ...data, limit: data.limit || 20 };
    return get(`${process.env.REACT_APP_API_URL}cms/v2/contents`, { params });
  },
  getTotalContentSize: (data = {}) => {
    const params = { ...data };
    return get(`${process.env.REACT_APP_API_URL}cms/v1/contents/total-content-size`, { params });
  },
  getSingleContent: (data = 0) => get(`${process.env.REACT_APP_CMS_API_URL}cms/v1/contents/${data}`, {}),
  addContent: (data = {}) => {
    const body = { ...data };
    return post(`${process.env.REACT_APP_API_URL}cms/v2/contents`, body, true);
  },
  updateContent: (data, id) => patch(`${process.env.REACT_APP_API_URL}cms/v2/contents/${id}`, data, true),
  updateNameContent: (data, id) => patch(`${process.env.REACT_APP_API_URL}cms/v2/contents/name/${id}`, data),
  deleteContent: (data = {}) => {
    const params = { ...data };
    return deletev2(`${process.env.REACT_APP_API_URL}cms/v2/contents`, { params });
  },
  myContentExport: (data = {}) => {
    const params = { ...data };
    return get(`${process.env.REACT_APP_API_URL}cms/v2/contents/export`, { params });
  },
  uploadResizedImage: (id, data) => patch(
    `${process.env.REACT_APP_API_URL}cms/v1/contents/resized-content-upload/${id}`,
    data,
    true,
  ),
  MultiDeleteContent: (data = {}) => {
    const body = { ...data };
    return post(`${process.env.REACT_APP_API_URL}cms/v2/contents/update-related-schedules`, body);
  },
  getChartDetails: () => get(`${process.env.REACT_APP_API_URL}cms/v2/contents/chart`),
  getTags: () => get(`${process.env.REACT_APP_API_URL}cms/v2/contents/tag`),
  getAuthors: () => get(`${process.env.REACT_APP_API_URL}cms/v2/contents/author`),

  checkSchedule: (data = {}) => {
    const body = { ...data };
    return post(`${process.env.REACT_APP_API_URL}cms/v2/contents/check-schedule`, body);
  },
};
